import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.4rem;
  max-width: 1500px;
  gap: .6rem;

  @media (max-width: 768px) {
    padding-top: 1rem;
  }
`

export const CustomButton = styled(ButtonMui)`
  width: 14rem;
  align-self: flex-start;
`
